const state = {
  prpglistings: JSON.parse(sessionStorage.getItem('prpglistings')) || [],
  prpglistings_error: null,
  new_prpglistings: JSON.parse(sessionStorage.getItem('newprpglistings')) || [],
  new_prpglistings_error: null,
  sold_prpglistings:
    JSON.parse(sessionStorage.getItem('soldprpglistings')) || [],
  sold_prpglistings_error: null,
};

const mutations = {
  prpglistings(state) {
    state.prpglistings_error = null;
  },
  prpglistingsFailed(state, payload) {
    state.prpglistings_error = payload.error;
  },
  prpglistingsSuccess(state, payload) {
    state.prpglistings_error = null;
    state.prpglistings = payload;

    sessionStorage.setItem('prpglistings', JSON.stringify(state.prpglistings));
  },
  newPrpglistings(state) {
    state.new_prpglistings_error = null;
  },
  newPrpglistingsFailed(state, payload) {
    state.new_prpglistings_error = payload.error;
  },
  newPrpglistingsSuccess(state, payload) {
    state.new_prpglistings_error = null;
    state.new_prpglistings = payload;

    sessionStorage.setItem(
      'newprpglistings',
      JSON.stringify(state.new_prpglistings)
    );
  },
  soldPrpglistings(state) {
    state.sold_prpglistings_error = null;
  },
  soldPrpglistingsFailed(state, payload) {
    state.sold_prpglistings_error = payload.error;
  },
  soldPrpglistingsSuccess(state, payload) {
    state.sold_prpglistings_error = null;
    state.sold_prpglistings = payload;

    sessionStorage.setItem(
      'soldprpglistings',
      JSON.stringify(state.sold_prpglistings)
    );
  },
};

const actions = {
  prpglistings: ({ commit }) => commit('prpglistings'),
  newPrpglistings: ({ commit }) => commit('newPrpglistings'),
  soldPrpglistings: ({ commit }) => commit('soldPrpglistings'),
};

const getters = {
  prpglistingsError: (state) => state.prpglistings_error,
  newPrpglistingsError: (state) => state.new_prpglistings_error,
  soldPrpglistingsError: (state) => state.sold_prpglistings_error,
  prpglistings: (state) => state.prpglistings,
  newPrpglistings: (state) => state.new_prpglistings,
  soldPrpglistings: (state) => state.sold_prpglistings,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
